module.exports = __webpack_public_path__ + "img/slide_04_th.36c692c5.jpg";